import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { RecoilRoot } from "recoil";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import reportWebVitals from "./reportWebVitals";
import { localConsole } from "@yoon0cean/common";

if (
  !window.location.href.includes("twww") &&
  !window.location.href.includes("tm") &&
  !window.location.href.includes("tim")
) {
  if (
    window.location.hostname.includes("code") &&
    !window.location.protocol.includes("s")
  ) {
    window.location.href = window.location.href.replace("http", "https");
  }
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <RecoilRoot>
    <BrowserRouter>
      <HelmetProvider>
        {/* <React.StrictMode> */}
        <App />
        {/* </React.StrictMode> */}
      </HelmetProvider>
    </BrowserRouter>
  </RecoilRoot>
);

reportWebVitals(localConsole?.log);
